<script setup>
import { Loc } from 'main.core';
import { computed } from 'ui.vue3';
import CalculatorSummary from './Summary/CalculatorSummary.vue';
import InfoBlock from './InfoBlock.vue';
import useCalculatorStore from '../store/calculator.js';

const calculator = useCalculatorStore();

const enterpriseTariffName = computed(() => {
  for (const tariff of calculator.tariffs) {
    if ('enterprise' === tariff.type) {
      return tariff.name;
    }
  }
  return '';
});
</script>

<template>
  <div class="cloud-calculator__sidebar">
    <CalculatorSummary/>
    <InfoBlock :modifiers="['info', 'mark', 'icon-lg', 'icon-inverted']">
      {{ Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_WARNING_AUTO_CALC') }}
    </InfoBlock>
    <InfoBlock :modifiers="['warning', 'enterprise', 'icon-lg']">
      {{ Loc.getMessage('1CR_STSL_CLOUD_CALCULATOR_WARNING_ENTERPRISE', { '#TARIFF#': enterpriseTariffName }) }}
    </InfoBlock>
  </div>
</template>
